import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import LogoUploader from "@/components/LogoUploader";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function TeamDialog({ open, onOpenChange, team, onSaved }) {
  const [name, setName] = useState("");
  const [accent, setAccent] = useState("#09090B");
  const [logo, setLogo] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    setName(team?.name || "");
    setAccent(team?.accent_color || "#09090B");
    setLogo(team?.logo_path || null);
  }, [team, open]);

  const save = async () => {
    if (!name.trim()) { toast.error("Skriv inn lagnavn"); return; }
    setSubmitting(true);
    try {
      let res;
      if (team) {
        res = await api.patch(`/teams/${team.id}`, { name, accent_color: accent, logo_path: logo });
      } else {
        res = await api.post("/teams", { name, accent_color: accent, logo_path: logo });
      }
      toast.success(team ? "Lag oppdatert" : "Lag opprettet");
      onSaved && onSaved(res.data);
      onOpenChange(false);
    } catch (e) {
      toast.error("Feil ved lagring");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-sm max-w-lg">
        <DialogHeader>
          <DialogTitle className="font-heading uppercase tracking-tight text-2xl">{team ? "Rediger lag" : "Nytt lag"}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label className="text-xs uppercase tracking-widest">Lagnavn</Label>
            <Input data-testid="team-name-input" value={name} onChange={(e) => setName(e.target.value)} className="rounded-sm" />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-widest">Lagfarge (HEX)</Label>
            <div className="flex items-center gap-3">
              <Input data-testid="team-color-input" type="color" value={accent} onChange={(e) => setAccent(e.target.value)} className="w-16 h-10 p-1 rounded-sm" />
              <Input value={accent} onChange={(e) => setAccent(e.target.value)} className="rounded-sm" />
            </div>
          </div>
          <LogoUploader value={logo} onChange={setLogo} label="Lag-logo" testid="team-logo" />
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)} className="rounded-sm">Avbryt</Button>
          <Button data-testid="save-team-btn" disabled={submitting} onClick={save} className="bg-black text-white hover:bg-neutral-800 rounded-sm font-heading uppercase tracking-widest">
            {submitting ? "Lagrer…" : "Lagre"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
